import { render, staticRenderFns } from "./MultiAssignButton.vue?vue&type=template&id=7572f2d6"
import script from "./MultiAssignButton.vue?vue&type=script&lang=js"
export * from "./MultiAssignButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports